import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Section, EmptyState } from "@/components/Primitives";
import { toast } from "sonner";
import { UploadSimple, Trash, DownloadSimple } from "@phosphor-icons/react";

const CLASS_GROUPS = ["Class 9", "Class 10", "Class 11", "Class 12", "B.Com", "B.Sc", "B.CA"];

export default function TeacherMaterials() {
  const [subjects, setSubjects] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [form, setForm] = useState({
    title: "", type: "note", subject_id: "", chapter_id: "", class_group: "Class 10", file_url: "", description: ""
  });

  const load = () => api.get("/materials").then(r => setMaterials(r.data));
  useEffect(() => { load(); api.get("/subjects").then(r => setSubjects(r.data)); }, []);

  const subj = subjects.find(s => s.id === form.subject_id);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.subject_id || !form.file_url) { toast.error("Select subject and add a link"); return; }
    try {
      await api.post("/materials", form);
      toast.success("Material uploaded");
      setForm({ title: "", type: "note", subject_id: "", chapter_id: "", class_group: "Class 10", file_url: "", description: "" });
      load();
    } catch { toast.error("Failed"); }
  };

  const del = async (id) => { if (!confirm("Delete?")) return; await api.delete(`/materials/${id}`); load(); };

  return (
    <div>
      <PageHeader eyebrow="Archive" title="Study material" subtitle="Notes, PPTs, recorded lectures and videos." />

      <Section title="Publish material">
        <form onSubmit={submit} className="card-academic p-6 grid md:grid-cols-2 gap-4">
          <input placeholder="Title" required value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} data-testid="m-title"
            className="bg-ivory border border-stone px-4 py-3 md:col-span-2" />
          <select value={form.type} onChange={e => setForm({ ...form, type: e.target.value })} data-testid="m-type" className="bg-ivory border border-stone px-4 py-3">
            <option value="note">Notes</option>
            <option value="ppt">PPT</option>
            <option value="video">Video</option>
            <option value="lecture">Recorded lecture</option>
          </select>
          <select value={form.class_group} onChange={e => setForm({ ...form, class_group: e.target.value })} data-testid="m-class" className="bg-ivory border border-stone px-4 py-3">
            {CLASS_GROUPS.map(c => <option key={c}>{c}</option>)}
          </select>
          <select value={form.subject_id} onChange={e => setForm({ ...form, subject_id: e.target.value, chapter_id: "" })} data-testid="m-subject" className="bg-ivory border border-stone px-4 py-3">
            <option value="">— Subject —</option>
            {subjects.filter(s => s.class_group === form.class_group).map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
          <select value={form.chapter_id} onChange={e => setForm({ ...form, chapter_id: e.target.value })} data-testid="m-chapter" className="bg-ivory border border-stone px-4 py-3">
            <option value="">— Chapter (optional) —</option>
            {subj?.chapters.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
          <input placeholder="File URL (Google Drive / direct link)" required value={form.file_url} onChange={e => setForm({ ...form, file_url: e.target.value })} data-testid="m-url"
            className="bg-ivory border border-stone px-4 py-3 md:col-span-2" />
          <textarea placeholder="Description (optional)" value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} data-testid="m-desc"
            className="bg-ivory border border-stone px-4 py-3 md:col-span-2" rows={2} />
          <button className="btn-primary md:col-span-2 flex items-center gap-2 justify-center" data-testid="m-submit"><UploadSimple size={16} /> Publish</button>
        </form>
      </Section>

      <Section title={`Uploaded (${materials.length})`}>
        {materials.length === 0 ? <EmptyState /> : (
          <div className="grid md:grid-cols-2 gap-4">
            {materials.map(m => (
              <div key={m.id} className="card-academic p-5 flex justify-between items-start">
                <div className="flex-1">
                  <div className="overline">{m.type} · {m.class_group}</div>
                  <h4 className="font-serif text-lg text-forest">{m.title}</h4>
                  {m.description && <p className="text-sm text-mossy mt-1">{m.description}</p>}
                  <div className="flex items-center gap-4 mt-3 text-xs font-mono text-mossy">
                    <span className="flex items-center gap-1"><DownloadSimple size={12} /> {m.download_count}</span>
                    <a href={m.file_url} target="_blank" rel="noreferrer" className="text-terracotta underline underline-offset-4">Open</a>
                  </div>
                </div>
                <button onClick={() => del(m.id)} className="text-mossy hover:text-terracotta" data-testid={`del-mat-${m.id}`}><Trash size={16} /></button>
              </div>
            ))}
          </div>
        )}
      </Section>
    </div>
  );
}
